export function getComponentPadding({ topPadding, bottomPadding }) {
    return [
        topPadding === 'sm' && 'component-padding-t-sm',
        topPadding === 'md' && 'component-padding-t-md',
        topPadding === 'lg' && 'component-padding-t-lg',
        topPadding === 'xl' && 'component-padding-t-xl',
        bottomPadding === 'sm' && 'component-padding-b-sm',
        bottomPadding === 'md' && 'component-padding-b-md',
        bottomPadding === 'lg' && 'component-padding-b-lg',
        bottomPadding === 'xl' && 'component-padding-b-xl',
    ]
        .filter(Boolean)
        .join(' ');
}
